// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--C707C","message":"a10a3f92e9--message--DLohr","name":"a10a3f92e9--name--GyKCJ"};